// src/graphql/mutations/deepCrawlMutations.js

export const deleteDeepCrawlSiteConfig = `mutation DeleteDeepCrawlSiteConfig($domain: String!) {
    deleteDeepCrawlSiteConfig(domain: $domain) {
        success
        message
        error
    }
}`;

export const cleanupDeepCrawlTelemetry = `mutation CleanupDeepCrawlTelemetry($olderThanDays: Int!) {
    cleanupDeepCrawlTelemetry(olderThanDays: $olderThanDays) {
        success
        message
        deletedCount
        error
    }
}`;
